import { gql } from '@apollo/client';

const DSP_INVOICE_FIELDS = `
    invoiceId
    billId
    dspId
    invoiceNo
    invoiceAmount
    currency
    invoiceDate
    status
    submitted
    generationType
    isSelfMade
    isParseFailed
    pdfPreviewUrl
    pdfDownloadUrl
    fileName
    fileExtension
    version
    cancelReason
    cancelledAt
    createdAt
    amountMismatch
`;

/** 总部：查账单当前有效的 DSP Invoice */
export const GET_DSP_INVOICE_BY_BILL_ID = gql`
    query GetDspInvoiceByBillId($billId: ID!) {
        getDspInvoiceByBillId(billId: $billId) { ${DSP_INVOICE_FIELDS} }
    }
`;

/** 总部：查账单全部 DSP Invoice（含已作废） */
export const LIST_DSP_INVOICE_BY_BILL_ID = gql`
    query ListDspInvoiceByBillId($billId: ID!) {
        listDspInvoiceByBillId(billId: $billId) { ${DSP_INVOICE_FIELDS} }
    }
`;

/** HUB：查账单当前有效的 DSP Invoice */
export const GET_HUB_DSP_INVOICE_BY_BILL_ID = gql`
    query GetHubDspInvoiceByBillId($hubId: Long!, $billId: ID!) {
        getHubDspInvoiceByBillId(hubId: $hubId, billId: $billId) { ${DSP_INVOICE_FIELDS} }
    }
`;

/** DSP Owner：查自身账单当前有效的 Invoice */
export const GET_MY_DSP_INVOICE_BY_BILL_ID = gql`
    query GetMyDspInvoiceByBillId($billId: ID!) {
        getMyDspInvoiceByBillId(billId: $billId) { ${DSP_INVOICE_FIELDS} }
    }
`;

/** DSP Owner：生成前的财务档案完整性校验，返回缺失字段清单 */
export const VALIDATE_MY_DSP_INVOICE_FINANCE_INFO = gql`
    query ValidateMyDspInvoiceFinanceInfo($billId: ID!) {
        validateMyDspInvoiceFinanceInfo(billId: $billId) {
            fieldName
            label
        }
    }
`;
